import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';

export const useColorStatuses = defineStore('color-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.colorStatus_GetList,
    dto: 'ColorStatusDto',
    create: api.colorStatus_Create,
    update: api.colorStatus_Update,
    delete: api.colorStatus_Delete,
    usage: api.colorStatus_GetUsage,
    signalR: 'ColorStatusUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.colorStatus_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  return {
    ...globalStoreBase,
    replace,
  };
});
